import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* monthlyReportWatchers() {
  yield all([
    takeEvery(
      EntryActionTypes.MONTHLY_REPORT_IN_CURRENT_BOARD_FETCH,
      ({ payload: { year, month, listId, pointSystemId } }) =>
        services.fetchMonthlyReportInCurrentBoard(year, month, listId, pointSystemId),
    ),
  ]);
}

